import { createTheme, ThemeOptions } from '@mui/material/styles'
import { tokens } from './tokens'
import { typography } from './typography'
import { components } from './components'
import { fontFaces } from './fonts'

// Theme version for maintenance
export const themeVersion = '1.0.0'

// Theme factory function
const createAppTheme = (mode: 'light' | 'dark') => {
  const colors = tokens.colors[mode]

  return createTheme({
    palette: {
      mode,
      primary: {
        ...colors.primary,
        contrastText: tokens.colors.common.white,
      },
      secondary: {
        ...colors.secondary,
        contrastText: tokens.colors.common.white,
      },
      success: {
        ...colors.success,
        contrastText: tokens.colors.common.white,
      },
      warning: {
        ...colors.warning,
        contrastText: tokens.colors.common.white,
      },
      error: {
        ...colors.error,
        contrastText: tokens.colors.common.white,
      },
      info: {
        ...colors.info,
        contrastText: tokens.colors.common.white,
      },
      neutral: {
        ...colors.neutral,
        contrastText: tokens.colors.common.white,
      },
      text: {
        ...colors.text,
      },
      divider: colors.divider,
      gradient: {
        ...tokens.colors.common.gradient,
      },
      overlay: {
        ...tokens.colors.common.overlay,
      },
      background: {
        ...colors.background,
      },
      common: {
        ...tokens.colors.common,
      },
    },
    typography,
    components,
    fontFaces,
    // Add animation values from tokens
    animation: {
      durations: tokens.animation.durations,
      easings: tokens.animation.easings,
      transitions: tokens.animation.transitions,
    },
  } as ThemeOptions)
}

export const lightTheme = createAppTheme('light')
export const darkTheme = createAppTheme('dark')

export { tokens }
